module.exports = MaterialUI.ListItemIcon;